import { render, staticRenderFns } from "./airQuality.vue?vue&type=template&id=8285f300&"
import script from "./airQuality.vue?vue&type=script&lang=js&"
export * from "./airQuality.vue?vue&type=script&lang=js&"
import style0 from "./airQuality.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports